var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"preloader"},[_vm._m(0),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.notice) || _vm.$t("f-n-5")))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"image"},[_c('img',{attrs:{"src":require("@/assets/img/preloader.svg")}})])
}]

export { render, staticRenderFns }